import React from 'react';
import { CalendarDays, Clock, MapPin } from 'lucide-react';
import OrderChip from '../Brand/OrderChip';
import TravelInfo from '../Travel/TravelInfo';
import { ukDate, ukTime } from '../../lib/format';

// The one job a staff member needs to see first, on mobile
export const NextJobCard = ({ job, token }) => {
  if (!job) return null;

  return (
    <div className="bd-card bd-card-accent bd-fade-up mb-5 p-4" data-testid="next-job-card">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold-deep">Your next job</p>
          <h2 className="mt-1 truncate text-base text-ink">{job.job_type}</h2>
        </div>
        <OrderChip value={job.order_number || job.job_number} fallback="" testId="next-job-order" />
      </div>

      <div className="grid gap-2 text-sm text-slate-600">
        <p className="flex items-center gap-2">
          <CalendarDays className="h-4 w-4 shrink-0 text-gold-deep" />
          <span className="font-semibold text-ink">{ukDate(job.date, { withYear: false })}</span>
        </p>
        {(job.time || job.time_start) && (
          <p className="flex items-center gap-2">
            <Clock className="h-4 w-4 shrink-0 text-gold-deep" />
            <span>{ukTime(job.time_start || job.time) || job.time}</span>
          </p>
        )}
        {job.location && (
          <p className="flex items-start gap-2">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" />
            <span className="break-words">{job.location}</span>
          </p>
        )}
      </div>

      <TravelInfo jobId={job.id} token={token} className="mt-3" />
    </div>
  );
};

export default NextJobCard;
